import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The project's font-size scale, from `@theme inline` in index.css.
 *
 * tailwind-merge has to be told about these, and getting it wrong is not a
 * cosmetic problem. Its default config knows `text-xs … text-9xl` as font sizes
 * and classifies every OTHER `text-*` as a colour. So `text-body` was being
 * filed as a colour, put in the same conflict group as `text-[var(--on-brand)]`,
 * and — because the size class is appended after the variant classes in
 * `Button` — the COLOUR was dropped from the output entirely.
 *
 * The visible symptom was the primary button rendering its label in
 * `--text-primary` (near-black) on the brand blue: 2.7:1, a WCAG AA failure on
 * the most-pressed control in the app. Every component that combined one of
 * these sizes with a `text-[…]` colour had the same silent failure.
 */
const FONT_SIZES = ['caption', 'body-sm', 'body', 'title', 'display'];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: FONT_SIZES }]
    }
  }
});

/**
 * Joins class names and lets a caller's `className` override the component's own
 * utilities instead of losing to whichever rule Tailwind emitted last.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
